<template>
    <v-form @submit.prevent="onSubmit($event)">
    <v-card class="elevation-12">
        <v-toolbar flat tabs color="grey lighten-3">
            <v-toolbar-side-icon @click="exit">
                <v-icon color="primary">close</v-icon>
            </v-toolbar-side-icon>            
            <v-toolbar-title v-if="typeFormDialogUpdate">Editar serviço</v-toolbar-title>                        
            <div>          
                <v-switch style="margin-left:5%;"                 
                v-model="typeFormDialogUpdate.enabled"
                label="Ativo"
                color="primary"
                hide-details                
                >
                </v-switch>
            </div>
        </v-toolbar>
        <v-card-text class="pt-0" id="typeFormDialogUpdate">           
            <v-container grid-list-md pa-0 fluid>
                <v-layout row wrap>
                    <v-flex xs12 sm15>
                        <v-layout row wrap justify-center>
                             <v-flex xs12>
                                <v-text-field  
                                label="Nome serviço" type="text" 
                                outline
                                v-model="typeFormDialogUpdate.name" 
                                required                                
                                clearable 
                                v-validate="'required'"
                                data-vv-name="name"
                                :error-messages="errors.collect('id')"
                                full-width
                                                                
                                ></v-text-field>
                            </v-flex>                          
                        </v-layout>
                    </v-flex>
                     
                </v-layout>
            </v-container>
            <span id="errorType" class="error--text">{{error}}</span>
        </v-card-text>
        <v-card-actions class="row layout justify-center">
            <v-btn color="success" large type="submit" class="mb-3" :loading="loading" :disabled="loading">
                Salvar Serviço
            </v-btn>
        </v-card-actions>
    </v-card>
    </v-form>
    </template>        
    <script>    
    import {mapGetters} from 'vuex'    
    export default {
        $_veeValidate: {
            validator: 'new'
        },        
        data(){
            return {
                error:'',
                typeFormDialogUpdate:{
                    name:'',
                    description:'',
                    id:'',
                    enabled:true,
                },                                             
                loading:false,                           
            }
        },
        computed:{
            ...mapGetters([
                'util',
                'restaurant',
                'menu',
                'type',
                'typeDialogCategoryUpdate',
                'typeSelected',
                'currentServiceTypeId',
                'currentServiceTypeName'
            ])
        },
        watch:{
            typeDialogCategoryUpdate(v){
                if(v){
                    this.setForm()
                }
            },          
            error(v){
                if(v){
                    this.$vuetify.goTo('#errorType','#typeForm')
                }
            }
        },
        methods:{           
            async setForm(){                           
                if(this.typeFormDialogUpdate){
                    this.typeFormDialogUpdate = Object.assign({...this.typeFormDialogUpdate, id:this.currentServiceTypeId, name:this.currentServiceTypeName})                    
                }                                  
            },          
            exit(){
                this.typeFormDialogUpdate = {
                    name:'',
                    description:'',
                    id:'',
                    enabled:true,
                }
                this.error = ''
                this.$validator.reset()
                setTimeout(() => {
                    this.$emit('close')
                }, 200);
            },           
        async onSubmit(event){            
            let valid = await this.$validator.validateAll()
            if(valid){
                 this.loading = true                
                 const data={                    
                     id:this.typeFormDialogUpdate.id,
                     name: this.typeFormDialogUpdate.name,
                     enabled: this.typeFormDialogUpdate.enabled
                 }                
                this.$store.dispatch('updateServiceType',data).then(res=>{                    
                    if(!res.ok){                                                
                        this.error = res.error                        
                    }else{                                                
                        this.$store.commit('FETCH_TYPE',null)
                        this.exit()                        
                    }
                    this.loading = false                    
                })
                .catch(err=>{
                    console.log(err);
                    this.error = "Ocorreu um erro inesperado."
                    this.loading = false
                })
            }
        },
      }
    }
    </script>
    <style>    
    </style>
    